<template lang="pug">
  component.button(:is="componentName" v-bind="$attrs" v-on="$listeners")
    b-icon(v-if="icon" :icon="icon" :type="iconType")
    span(v-if="label") {{ label }}
    span(v-if="icon && $slots.default")
      slot
    slot(v-else)
</template>

<script>
export default {
  name: 'ui-button',

  props: {
    icon: String,
    label: String,
    iconType: String,
  },

  computed: {
    componentName() {
      return this.$attrs.to ? 'router-link' : 'button';
    },
  },
};
</script>
